import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { colourWhite, colourMasterLight } from 'Styles/colors.css';
import { UI } from 'SharedConstants/';
import { SELECTED_CONTAINER, SETTINGS_PANEL_WIDTH } from 'PreviewConstants/';
import { getAdId } from 'Selectors';
import { getActivePageLayout, getURLSafeLayoutName } from 'PreviewSelectors';
import { imageToBlob } from 'Shared/utils/utils';

import LayoutRecord from 'PreviewRecords/LayoutRecord';
import WveStyleElementLabel from 'Components/WveSettingsPanel/WveStyleElement/WveStyleElementLabel/WveStyleElementLabel';
import WveLinkButton from 'SharedComponents/WveInputs/WveLinkButton/WveLinkButton';
import WveInputCheckbox from 'SharedComponents/WveInputs/WveInputCheckbox/WveInputCheckbox';
import WveStyleElement from 'Components/WveSettingsPanel/WveStyleElement/WveStyleElement';


const Container = styled.div`
    position: fixed;
    margin-bottom: 0;
    z-index: 500;
    border-left: 1px solid ${colourMasterLight};
    width: ${SETTINGS_PANEL_WIDTH}px;
    right: -${SETTINGS_PANEL_WIDTH}px;
    bottom: 0px;
    top: 0px;
    background-color: ${colourWhite}
`;

const ActionButtonsContainer = styled.div`
  position: absolute;
  display: flex;
  right: 0;
  margin: 6px;
  margin-top: 0;
`;

const PanelContents = styled.div`
  position: relative;
`;

const QRCode = styled.img`
  display: block;
  position: relative;
  width: 125px;
  height: auto;
  margin-top: 10px;
`;

const MonitorLog = styled.pre`
  width: 100%;
  height: calc(100vh - 200px);
  background-color: #fff;
  background-image: none;
  border: 1px solid rgba(0, 0, 0, 0.07);
  background-color: #fafafa;
  font-family: Menlo,Monaco,Consolas,"Courier New",monospace;
  font-size: 13px;
  padding: 8px 9px;
  margin-top: 5px;
  white-space: pre;
`;

class EventsPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter:'',
      hideHoverEvents:false
    };
  }
  filterChange = (event)=>{
    this.setState({filter: event.filter});

  }
  toggleHideHoverEvents = (event) =>{
    this.setState({ hideHoverEvents: !this.state.hideHoverEvents});

  }
  render() {
    const { adId, activeLayout, eventLog, selectedContainer } = this.props;
    const safeName = activeLayout ? getURLSafeLayoutName(activeLayout.name) : '';
    const previewPath = (selectedContainer === 'responsive') ? selectedContainer : `${selectedContainer}/${safeName}`;

    var filtered = eventLog;
    if(this.state.hideHoverEvents){
      filtered = eventLog.filter(function (str) { return !/(mouseover|dwell|hover)$/.test(str);});
    }
    if(this.state.filter !=''){
      //filtered = filtered.filter(function (str, fil=this.state.filter) { return String(str).toLowerCase().indexOf(String(fil).toLowerCase())>-1;});
      filtered = filtered.filter(function (str, id, arr) { return String(str).toLowerCase().indexOf(String(this.filter).toLowerCase())>-1;},{'filter':this.state.filter});
    }

    const eventLogStr = filtered.join('\n');


    return (
      <PanelContents>
        <div style={{ paddingLeft: '15px', marginTop: '10px' }} >
          <WveStyleElement
                field={{ mapping: 'filter', label: 'Filter', inputType: 'text' }}
                //onChange={this.filterChange}
                value={this.state.filter}
                disabled={false}
                placeholder="Filter ad events"
                updateFunction={this.filterChange}
              />
          <MonitorLog>{`${eventLogStr}`}</MonitorLog>
          <WveStyleElementLabel label="hide hover events" />
          <WveInputCheckbox
            id="monitor-hide-hover-events"
            value={this.state.hideHoverEvents}
            onChange={this.toggleHideHoverEvents}
            placeholder=""
            disabled={false}
            label=""
          />
        </div>
      </PanelContents>);
  }

}

// export default SideBar;

EventsPanel.propTypes = {
  adId: PropTypes.number,
  activeLayout: PropTypes.instanceOf(LayoutRecord),
  eventLog: PropTypes.array,
  selectedContainer: PropTypes.string,
};

EventsPanel.defaultProps = {
  adId: null,
  activeLayout: null,
  eventLog: '',
  selectedContainer: 'standard',
};

const mapStateToProps = state => ({
  adId: getAdId(state),
  activeLayout: getActivePageLayout(state),
  selectedContainer: state.getIn([UI, SELECTED_CONTAINER]),
});

export default connect(mapStateToProps, null)(EventsPanel);



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/components/SideBar/Panels/EventsPanel.jsx